import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersDocumentFileCategoriesRequestIndex,
  ApiManagersDocumentFileCategoriesResponseIndex,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersDocumentFileCategoriesRequestIndex;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersDocumentFileCategoriesResponseIndex> => {
  const response =
    await new ApiClient().get<ApiManagersDocumentFileCategoriesResponseIndex>(
      "/api/managers/document_file_categories",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersDocumentFileCategoriesRequestIndex;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersDocumentFileCategoriesIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersDocumentFileCategoriesResponseIndex> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersDocumentFileCategoriesIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
